export const UPDATE_PURPOSE = "UPDATE_PURPOSE"
export const UPDATE_PROGRAM = "UPDATE_PROGRAM"
export const UPDATE_CREATION_METHOD = "UPDATE_CREATION_METHOD";
export const UPDATE_SWIFT_READABLE_ID = "UPDATE_SWIFT_READABLE_ID";
export const RESET_SWIFT_READABLE_ID = "RESET_SWIFT_READABLE_ID";